export const emeaFilterByConstants = {
  EMEA_FILTER_BY_DC_SO_LOADING: 'EMEA_FILTER_BY_DC_SO_LOADING',
  EMEA_FILTER_BY_DC_SO_SUCCESS: 'EMEA_FILTER_BY_DC_SO_SUCCESS',
  EMEA_FILTER_BY_DC_SO_FAILED: 'EMEA_FILTER_BY_DC_SO_FAILED',
}